import { autoinject, bindable } from 'aurelia-framework';

@autoinject
export class ValueWithTolerance {
  @bindable private mainValue: string;
  @bindable private valueToleranceUp: string;
  @bindable private valueToleranceDown: string;
  constructor() {}
}
